import Image from 'molecules/Image';
import RichText from 'molecules/RichText';

import type { ImageCardConfigProps } from 'organisms/Cards/ImageCard/config';
import type { FC } from 'react';

const ImageCard: FC<ImageCardConfigProps> = ({ image, title, subhead, description }) => {
  const imageUrl = image?.file?.url;
  const imageWidth = image?.file?.width;
  const imageHeight = image?.file?.height;

  return (
    <div className="relative flex h-full flex-col">
      <div className="relative w-full overflow-hidden rounded-md">
        {imageUrl && (
          <Image
            url={imageUrl}
            alt={image?.alt || title || 'Card image'}
            noFill
            width={imageWidth || 1280}
            height={imageHeight || 720}
            className="w-full"
            sizes="(max-width: 640px) 90vw, (max-width: 1024px) 45vw, 400px"
          />
        )}
      </div>

      <div className="relative flex flex-1 flex-col rounded-b-lg border border-primary-1100 bg-imageCardOverlay px-5 pb-5 pt-7 backdrop-blur-[5px]">
        {(title || subhead) && (
          <div className="flex flex-col">
            {title && <h3 className="font-spaceGrotesk text-3xl font-semibold leading-9 text-white">{title}</h3>}
            {subhead && <p className="font-roboto text-xl font-medium leading-8 text-white">{subhead}</p>}
          </div>
        )}
        {description && (
          <RichText text={description} className="mt-4 font-roboto text-md font-medium leading-6 text-gray-300" />
        )}
      </div>
    </div>
  );
};

export default ImageCard;
